import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function StatusPinjaman() {
  const { id, npp } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  
  const [dataPinjaman, setDataPinjaman] = useState([]);
  const [empDataPinjaman, setEmpDataPinjam] = useState([]);
  const [listNoPinjam, setListNoPinjam] = useState([]);
  const [noPinjam, setNoPinjam] = useState([]);
  const [empData, setEmpData] = useState([]);


  // CONTROLLER

  const fetchDataPinjaman = async (id) => {
    setIsLoading(true);
    await baseAPI 
      .get(`/v1/statuspinjaman/${id}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.pinjaman;

        const listPinjam = [];
        data.forEach(e => {
          listPinjam.push({ label: e.notrxdetailpinjam, value: e.notrxpinjam })
        });

        setListNoPinjam(listPinjam);
        setDataPinjaman(data);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const fetchUserData = async (id) => {
    setIsLoading(true);
    await baseAPI 
      .get(`/v1/user/${id}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.userData;       
        setEmpData(data[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const checkStatusPinjam = (nopinjam) => {

    let data = [];
    dataPinjaman.forEach(e => {
      if(e.notrxpinjam == nopinjam) {
        data.push({
          trxpinjam: moment(e.trxpinjam).format("DD/MM/YYYY"),
          plafond: "Rp." + parseFloat(e.plafond).toLocaleString('id-ID'),
          sisapokok: "Rp." + parseFloat(e.plafond - (e.cicilan_ke * e.cpokok)).toLocaleString('id-ID'),
          cicilanke: e.cicilan_ke + " dari " + e.lama,
          cicilan: "Rp." + parseFloat(parseInt((e.plafond / e.lama) + e.jasa_bulan)).toLocaleString('id-ID'),
          status: e.status,
          status_lunas: e.status_lunas
        })
      }
    });

    setEmpDataPinjam(data[0]);
  }

  useEffect(() => {
    // if (user.role === ANGGOTA) {
      fetchDataPinjaman(user.id);
      fetchUserData(user.id);
    // };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Pinjaman Tunai</Link> /{' '}
              <Link to='/tunai/statuspinjaman' style={{ color: '#333' }}>Status Pinjaman Tunai</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Pinjaman Tunai Anggota</b></p>
                <p>Silahkan memilih no pinjaman, kemudian anda akan melihat status serta data pinjaman anda. No pinjaman yang tersedia adalah pinjaman yang masih aktif.</p>
              </div>
              {/* No Pinjaman */}
              <div className='col-md-12 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Pinjaman
                </label>
                <Select
                  options={listNoPinjam}
                  defaultValue={listNoPinjam && noPinjam}
                  placeholder="Pilih no pinjaman"
                  onChange={e => {
                    setNoPinjam(e);
                    checkStatusPinjam(e.value);
                  }}
                />
              </div>

              {/* Tanggal Pengajuan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pengajuan
                </label>
                <input
                  defaultValue={empDataPinjaman.trxpinjam}
                  placeholder='Tanggal pengajuan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  placeholder='Employee name'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Besar pinjaman fix */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar pinjaman
                </label>
                <input
                  defaultValue={empDataPinjaman.plafond}
                  placeholder='Besar plafond'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Sisa pokok pinjaman fix */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Sisa Pokok
                </label>
                <input
                  defaultValue={empDataPinjaman.sisapokok}
                  placeholder='Sisa pokok'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Cicilan ke */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Ke
                </label>
                <input
                  defaultValue={empDataPinjaman.cicilanke}
                  placeholder='Cicilan ke'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Besar cicilan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Cicilan Total per Bulan
                </label>
                <input
                  defaultValue={empDataPinjaman.cicilan}
                  placeholder='Cicilan total'
                  className="form-control"
                  readOnly
                />
              </div>
              <div className='col-md-3'>
                <label className='form-label'>
                  Status:
                </label>
                <span className='badge' style={{backgroundColor: '#333'}}>{empDataPinjaman.status}</span>
              </div>
              {empDataPinjaman.status_lunas != null
              ?
              <div className='col-md-3'>
                <label className='form-label'>
                  Status Pelunasan:
                </label>
                <span className='badge bg-success'>{empDataPinjaman.status_lunas}</span>
              </div>
              : <></>}

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {/* {isLoading ? <LoadingView /> : addView()} */}
      {addView()}

    </div>
  );

}

export default StatusPinjaman;